import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useTheme } from "@mui/material/styles";

const NewsCard = (props) => {
  const theme = useTheme();


  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        border: "1px solid rgba(6, 57, 112, 0.1)",
        boxShadow: "0 14px 38px rgba(6, 57, 112, 0.08)",
        transition: "transform 220ms ease, box-shadow 220ms ease",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 24px 60px rgba(6, 57, 112, 0.16)",
        },
        "&:hover .news-media": {
          transform: "scale(1.05)",
        },
      }}
    >
      <CardActionArea
        component="a"
        href={props.articleUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${props.title.trim()} (opens in a new tab)`}
        sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <Box sx={{ width: "100%", overflow: "hidden" }}>
          <CardMedia
            component="img"
            className="news-media"
            sx={{
              height: 250,
              objectFit: "cover",
              transition: "transform 420ms ease",
            }}
            image={props.imageUrl}
            alt={props.title.trim()}
            loading="lazy"
            decoding="async"
          />
        </Box>
        <CardContent
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            p: 2.25,
          }}
        >
          <Typography
            variant="overline"
            color={theme.palette.primary.main}
            sx={{ fontWeight: 900 }}
          >
            Lacor Hospital
          </Typography>
          <Typography
            gutterBottom
            variant="h5"
            component={props.headingLevel || "h3"}
            sx={{
              fontWeight: 900,
              lineHeight: 1.25,
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
              overflow: "hidden",
            }}
          >
            {props.title.trim()}
          </Typography>
          <Button
            component="span"
            tabIndex={-1}
            role={undefined}
            endIcon={<OpenInNewIcon />}
            sx={{ mt: "auto", alignSelf: "flex-start" }}
          >
            Read article
          </Button>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default NewsCard;
